import React from "react";

const PercentageColor = () => {
  return (
    <div className="flex items-center space-x-2 ">
      <div className="flex items-center space-x-1">
        <div className="h-3 w-3 bg-red-500"></div>
        <div className="text-[13px]">0 - 59</div>
      </div>
      <div className="flex items-center space-x-1">
        <div className="h-3 w-3 bg-yellow-500"></div>
        <div className="text-[13px]">60 - 79</div>
      </div>
      <div className="flex items-center space-x-1">
        <div className="h-3 w-3 bg-green-500"></div>
        <div className="text-[13px]">80 - 100</div>
      </div>
    </div>
  );
};

export default PercentageColor;
